import App from '../App.vue'

export default  {
    path: '/meeting',
    meta: { title: '会议详情' },
    component: App,
    children:[
        {
            path: 'detail/:id',
            component: () => import('../views/Meeting/Detail.vue'),
            meta: {
                title: '会议详情',
            }
        }
    ]
}